var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoDirectlyto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico_directlyto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_directlyto",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(8.000000, 12.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "27.168 8.247 29.831 8.247 29.831 5.584 27.168 5.584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.174,10.91 L32.826,10.91 L32.826,2.257 L24.174,2.257 L24.174,10.91 Z M22.174,12.91 L34.826,12.91 L34.826,0.257 L22.174,0.257 L22.174,12.91 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "48.8498 33.4683 50.8498 33.4683 50.8498 24.3593 41.8038 24.3593 41.8038 26.3593 48.8498 26.3593"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "6.2375 33.4683 8.2375 33.4683 8.2375 26.3593 14.9855 26.3593 14.9855 24.3593 6.2375 24.3593"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "51.6887 42.1274 49.8057 40.2444 47.9227 42.1274 49.8057 44.0104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.48,46.121 L54.132,46.121 L54.132,37.468 L45.48,37.468 L45.48,46.121 Z M43.48,48.121 L56.132,48.121 L56.132,35.468 L43.48,35.468 L43.48,48.121 Z",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "5.3108 42.1274 7.1948 44.0104 9.0778 42.1274 7.1948 40.2444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.867,46.121 L11.52,46.121 L11.52,37.468 L2.867,37.468 L2.867,46.121 Z M0.867,48.121 L13.52,48.121 L13.52,35.468 L0.867,35.468 L0.867,48.121 Z",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    points: "16.8391 29.0762 23.8931 29.0762 23.8931 48.1212 33.1081 48.1212 33.1081 29.0762 40.1611 29.0762 28.4051 15.2432"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDirectlyto);
export default __webpack_public_path__ + "static/media/ico_directlyto.372cf2e8723355f2d084630a4dbfe673.svg";
export { ForwardRef as ReactComponent };